import getToken from '@/composables/get-token';

export default function setApiHeaders(apiConfig) {
	apiConfig.headers.Authorization = `Bearer ${getToken()}`;

	return apiConfig;
}
